// Import model
import { FilterContactTaskRequest } from '../models/FilterContactTaskRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactTaskCondition } from '../models/ContactTaskCondition';
import { ContactTaskFields } from '../models/ContactTaskFields';
import { ContactTaskIndexedFields } from '../models/ContactTaskIndexedFields';

// Import dependency serializers (for complex types)
import { ContactTaskConditionSerializer } from './ContactTaskConditionSerializer';
import { ContactTaskFieldsSerializer } from './ContactTaskFieldsSerializer';
import { ContactTaskIndexedFieldsSerializer } from './ContactTaskIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterContactTaskRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterContactTaskRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterContactTaskRequest instance
   */
  static deserialize(json: string): FilterContactTaskRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterContactTaskRequest instance
   */
  static fromObject(obj: any): FilterContactTaskRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterContactTaskRequest');
    }


    const instance: FilterContactTaskRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as ContactTaskIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as ContactTaskFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        ContactTaskConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterContactTaskRequest instances
   */
  static deserializeArray(json: string): FilterContactTaskRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterContactTaskRequest instance to a JSON string
   */
  static serialize(instance: FilterContactTaskRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterContactTaskRequest instance to a plain object
   */
  static toObject(instance: FilterContactTaskRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        ContactTaskConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterContactTaskRequest instances to a JSON string
   */
  static serializeArray(instances: FilterContactTaskRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
